<script>
    let data = new Date();
    let run = () => {
        data = new Date();
        setTimeout(run, 1000);
    };
    setTimeout(run, 1000);
</script>

<div>
    <span
        >{data.toLocaleDateString("de-DE", {
            weekday: "long",
            day: "numeric",
            month: "long",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        })}</span
    >
</div>

<style>
    span {
        font-size: 16px;
    }
</style>
